import type { UserRoles } from 'src/common/enums';
import { useGetUserQuery } from 'src/common/slices';

export const useHasRole = (role: UserRoles) => {
  const { data: userData } = useGetUserQuery();
  return userData?.data?.user?.roles?.includes(role) ?? false;
};
